"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarouselItem = void 0;
const react_1 = __importDefault(require("react"));
const foundations_1 = require("../../foundations");
const SkeletonBox = ({ height }) => (react_1.default.createElement(foundations_1.Box, { sx: {
        background: "#FFF",
        borderRadius: "large",
        height,
        opacity: 0.5,
        width: "100%"
    } }));
const generateSkeletonBoxes = (containerHeight, boxHeight) => {
    const boxCount = Math.floor(containerHeight / (boxHeight * 4 + 4)); // * 4 to get pixel value, and + 4 for gap
    return Array.from({ length: boxCount }, (_, i) => (react_1.default.createElement(SkeletonBox, { height: boxHeight, key: i })));
};
const ContentCover = ({ id, transitionEnabled, sx, skeletonBoxHeight = 16 }) => {
    const coverRef = react_1.default.useRef(null);
    const skeletonBoxes = coverRef.current &&
        generateSkeletonBoxes(coverRef.current.clientHeight, skeletonBoxHeight);
    return (react_1.default.createElement(foundations_1.Box, { ref: coverRef, id: "item-content-cover", "data-testid": `content-cover` + (id ? `-${id}` : ""), sx: {
            backgroundColor: (sx === null || sx === void 0 ? void 0 : sx.backgroundColor) || "background02",
            borderRadius: "medium",
            bottom: 0,
            display: "flex",
            flexDirection: "column",
            gap: 4,
            height: "100%",
            left: 0,
            position: "absolute",
            px: 10,
            py: 6,
            right: 0,
            top: 0,
            transition: transitionEnabled ? "easeOutFast" : "none",
            width: "100%",
            zIndex: 4
        } }, skeletonBoxes));
};
const CarouselItem = ({ children, hideContent, id, sx, transitionEnabled = true }) => {
    return (react_1.default.createElement(foundations_1.Box, { id: `item-content${id ? `-${id}` : ""}`, sx: Object.assign({ alignItems: "center", backgroundColor: "background02", borderRadius: "large", boxShadow: "boxShadow01", color: "text01", display: "flex", flexDirection: "column", p: 5, position: "relative", overflow: "hidden" }, sx) },
        hideContent && (react_1.default.createElement(ContentCover, { id: id, transitionEnabled: transitionEnabled, sx: sx })),
        children));
};
exports.CarouselItem = CarouselItem;
//# sourceMappingURL=CarouselItem.js.map